import { Component, EventEmitter, Input, Output, SimpleChanges} from '@angular/core';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-ng-select-layout',
  templateUrl: './ng-select-layout.component.html',
  styleUrls: ['./ng-select-layout.component.scss']
})
export class NgSelectLayoutComponent {

  @Input() includeValidation: boolean = false;
  @Input() placeHolderText?: string = `Select`;
  @Input() model: any = undefined;
  @Input() items: any[] | any = [];
  @Input() disableInput: boolean = false;
  @Input() submitted: boolean = false;

  @Input() invalidText: string | undefined = undefined;

  @Output() modelChange = new EventEmitter<any>();

  ngOnInit() {
    if (typeof (this.model) === "string") {
      if (this.model.length == 0) {
        this.model = undefined
      }
    }
  }

} 
